
export const UPDATE_COUNT = 'UPDATE_COUNT'

export const updateCount = (count) => ({
  type: UPDATE_COUNT,
  count,
})
